export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7544.e295b4ff.jpg";